<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_data_scope') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.data_scope') }} <strong>{{ scope.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-data-scope-new *ngIf="newMode()"></app-data-scope-new>
            <app-data-scope-basedata *ngIf="editMode()" [scope]="scope" (setEdit)="setEdit($event)"></app-data-scope-basedata>
          </p-tabPanel>

          <p-tabPanel *ngIf="hasDimension('template')" [header]="dimensionHeader('template')" leftIcon="pi pi-clone" [disabled]="isDisabled('templates') || scope === null">
            <app-data-scope-templates *ngIf="editMode()" [scope]="scope" (setEdit)="setEdit($event)" (entryCountChange)="onLiveCount('template', $event)"></app-data-scope-templates>
          </p-tabPanel>

          <p-tabPanel *ngIf="hasDimension('businessunit')" [header]="dimensionHeader('businessunit')" leftIcon="pi pi-sitemap" [disabled]="isDisabled('businessunits') || scope === null">
            <app-data-scope-businessunits *ngIf="editMode()" [scope]="scope" (setEdit)="setEdit($event)" (entryCountChange)="onLiveCount('businessunit', $event)"></app-data-scope-businessunits>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
